export const customsClearanceStatus = {
  cleared: "Cleared",
  "on-hold": "On hold",
  "not-cleared": "Not cleared",
};
